/**
 * Check if two Int32 values are equal
 *
 * @param {import('./Int32Type.js').BrandedInt32} a - First value
 * @param {import('./Int32Type.js').BrandedInt32} b - Second value
 * @returns {boolean} True if equal
 */
export function equals(a, b) {
	return a === b;
}
